import { Language } from "../const";
import { CATEGORIES, type MEDIA_TYPE, type PublicationType } from "../../const";

export const otherListLanguageMap: Record<Language, string> = {
  [Language.EN]: "/data/en/pub/other-en.json",
  [Language.TC]: "/data/tc/pub/other-tc.json",
  [Language.SC]: "/data/sc/pub/other-sc.json",
};
export function getOtherUsefulInformationData(
  other_json: any[]
): PublicationType[] {
  const other: PublicationType[] = other_json?.map((item) => ({
    title: item?.title ?? "",
    date: item?.date ?? "",
    link: item?.url ?? "",
    external: item?.external === "true",
    mediaType: item?.type as MEDIA_TYPE, // PDF
    thumbnail: item?.thumb ?? "",
    category: [CATEGORIES.PUBLICATIONS],
  }));

  return other;
}
